import React from "react";
import "./SoftwareSkill.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

function SoftwareSkill(props) {
  return (
    <div>
      <div className="software-skills-main-div">
        <ul className="dev-icons">
          {props.logos.map((logo) => {
            // console.log("logo", logo);
            return (
              <>
                <OverlayTrigger
                  key={logo.skillName}
                  placement={"top"}
                  overlay={
                    <Tooltip id={`tooltip-top`}>
                      <strong>{logo.skillName}</strong>
                    </Tooltip>
                  }
                >
                  <li className="software-skill-inline" name={logo.skillName}>
                    <span
                      className="iconify"
                      data-icon={logo.fontAwesomeClassname}
                      style={logo.style}
                      data-inline="false"
                    ></span>
                  </li>
                </OverlayTrigger>
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  width="48"
                  height="48"
                  x="0"
                  y="0"
                  viewBox="0 0 512 512"
                  class=""
                >
                  <g>
                    <path
                      fill="#3178c6"
                      d="M50 0h412c27.614 0 50 22.386 50 50v412c0 27.614-22.386 50-50 50H50c-27.614 0-50-22.386-50-50V50C0 22.386 22.386 0 50 0z"
                      opacity="1"
                      data-original="#3178c6"
                      class=""
                    ></path>
                    <path
                      fill="#3178c6"
                      d="M50 0h412c27.614 0 50 22.386 50 50v412c0 27.614-22.386 50-50 50H50c-27.614 0-50-22.386-50-50V50C0 22.386 22.386 0 50 0z"
                      opacity="1"
                      data-original="#3178c6"
                      class=""
                    ></path>
                    <path
                      fill="#ffffff"
                      fill-rule="evenodd"
                      d="M316.939 407.424v50.061c8.138 4.172 17.763 7.3 28.875 9.386S368.637 470 380.949 470c21.219 0 44.448-3.035 62.602-14.784C461.615 443.525 470 424.076 470 403.044c0-15.637-4.851-30.684-15.807-42.081-16.429-17.091-39.516-24.022-60.255-34.183-10.389-5.09-24.727-12.992-24.727-26.361 0-3.441.887-6.543 2.661-9.307 7.132-11.113 22.973-13.376 35.057-13.376 13.717 0 28.189 3.071 40.926 8.76 4.434 1.982 8.529 4.276 12.285 6.884v-46.776c-7.616-2.92-15.937-5.084-24.962-6.492S415.797 238 404.112 238c-11.895 0-23.163 1.278-33.805 3.833s-20.006 6.544-28.093 11.967c-8.086 5.424-14.476 12.333-19.171 20.729-4.695 8.395-7.043 18.433-7.043 30.114 0 14.914 4.304 27.638 12.912 38.172 8.607 10.533 21.675 19.45 39.204 26.751 11.792 4.822 24.053 9.581 34.665 16.739 7.355 4.96 14.007 11.877 14.007 21.275 0 6.821-3.856 12.604-9.468 16.192-8.303 5.308-18.936 6.492-28.563 6.492-10.851 0-21.597-1.903-32.24-5.71-10.641-3.806-20.501-9.516-29.578-17.13zM232.78 284.082H297V243H118v41.082h63.906V467h50.874z"
                      clip-rule="evenodd"
                      opacity="1"
                      data-original="#ffffff"
                    ></path>
                  </g>
                </svg> */}
              </>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default SoftwareSkill;
